<template> 
    <div>
        <ATradeTable
        />
    </div>
</template>
<script>

export default {
    name: "SampleTradeTable",
}
</script>
